{
  "totalDebt": 0.00,
  "matchdayLoansDebt": 0.00,
  "legacyLoansDebt": 0.00,
  "nextInstallments": []
}
